import { Card, CardContent, Typography } from '@mui/material';
import MuiRegularButton from 'components/MuiExtras/Button/MuiRegularButton';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { RoutePaths } from 'routes/RouteConfig';
import { WithTranslation, withTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////////////////

type Props = RouteComponentProps & WithTranslation;

////////////////////////////////////////////////////////////////////////////////////////

class AccessDenied extends React.Component<Props> {
    public render() {
        return (
            <Card>
                <CardContent>

                    <Typography variant="h4">{this.props.t("Views.Public.AccessDenied.Msg1")}</Typography>

                    <Typography variant="body1">
                        <p>{this.props.t("Views.Public.AccessDenied.Msg2")}</p>
                        <p>{this.props.t("Views.Public.AccessDenied.Msg3")}</p>
                    </Typography>

                    <MuiRegularButton
                        color="secondary"
                        size="large"
                        onClick={() => { this.props.history.replace(RoutePaths.TimelineStartup); }}>
                        <span>{this.props.t("Common.Buttons.HomeText")}</span>
                    </MuiRegularButton>

                </CardContent>
            </Card>
        );
    }
}

export default withTranslation()(withRouter(AccessDenied));